export function infoCardSlider() {
    $('.info-cards-slider').slick({
        dots: true,
        infinite:false,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: "<button class=\"slide-arrow slick-next\" aria-label='button-next'><svg width=\"10\" height=\"16\" viewBox=\"0 0 10 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
            "<path d=\"M0.595703 2.2625L6.15846 8L0.595703 13.7375L2.30825 15.5L9.5957 8L2.30825 0.5L0.595703 2.2625Z\" fill=\"#000FAA\"/>\n" +
            "</svg></button>",
        prevArrow: "<button class=\"slide-arrow slick-prev\" aria-label='button-prev'><svg width=\"10\" height=\"16\" viewBox=\"0 0 10 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
            "<path d=\"M9.5957 13.7375L4.03295 8L9.5957 2.2625L7.88315 0.5L0.595703 8L7.88315 15.5L9.5957 13.7375Z\" fill=\"#000FAA\"/>\n" +
            "</svg></button>"
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/infoCardSlider.js